export default "__VITE_ASSET__gd4nYSgd__"